var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 0.333313H3.33335C1.86669 0.333313 0.68002 1.53331 0.68002 2.99998L0.666687 19C0.666687 20.4666 1.86669 21.6666 3.33335 21.6666H24.6667C26.1334 21.6666 27.3334 20.4666 27.3334 19V2.99998C27.3334 1.53331 26.1334 0.333313 24.6667 0.333313ZM24.6667 5.66665L14 12.3333L3.33335 5.66665V2.99998L14 9.66665L24.6667 2.99998V5.66665Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8db03b1a54968daed25062e20fce9e10.svg";
export { ForwardRef as ReactComponent };